<script setup>
import { defineProps, defineEmits} from "vue";
import TabelaDePagamentosDeAprovarContasAPagar from "./PagamentosDeAprovarContasAPagar/TabelaDePagamentosDeAprovarContasAPagar.vue";
import LinhaDeAprovarContasAPagarMostragem from "./LinhaDeAprovarContasAPagarMostragem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
]);

//==================================================================//
//===================== Altera Conta a Pagar =======================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    update.id = props?.contaAPagar?.id;
    emits('update:alteraContaAPagar',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeAprovarContasAPagarMostragem
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="props?.contaAPagar"
            @update:alteraContaAPagar="alteraContaAPagar"
        ></LinhaDeAprovarContasAPagarMostragem>

        <TabelaDePagamentosDeAprovarContasAPagar
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="props?.contaAPagar"
        ></TabelaDePagamentosDeAprovarContasAPagar>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: contents;
}

.c-table__row-group:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

</style>
